try{self['workbox:sw:5.1.3']&&_()}catch(e){}// eslint-disable-line